// 初始化监控工具
import createLog from '@xes/web-log'
const config = {
  eventid: 'laoshibang_pc',
  appid: process.env.NODE_ENV !== 'production' ? '1005788' : '1005785',
}
// 创建一个 日志实例, 并且挂载到 window.$L 上
export default function initMonitor() {
  return createLog.createGlobal('$L', config)
}
